import { createContext } from "react";

const EventContext = createContext({ instance: null });

export default EventContext;
